import { gql } from '@apollo/client'
import { client } from '../client';


const CONNECT_TRANSPORTS_MUTATION = gql`
  mutation Mutation($id: Int, $prevTransportId: Int) {
    connectTransports(id: $id, prevTransportId: $prevTransportId)
  }
`

interface ConnectTransportsData {
  id: number,
  prevTransportId: number,
}

interface ConnectTransportsVars {
  id?: number,
  prevTransportId?: number
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const connectTransports = (args: ConnectTransportsData) => {
  return client.mutate<ConnectTransportsData, ConnectTransportsVars>({
    mutation: CONNECT_TRANSPORTS_MUTATION,
    variables: args,
  })
}
